import axios from 'axios'
import { createWithEqualityFn } from 'zustand/traditional'
import { CRUDBaseStore } from './Base/CRUD'

interface QuotationStore extends Partial<CRUDBaseStore> {
	data: any[]
	selected: any
	setData: (data: any[]) => void
	setSelected: (selected: any) => void
	getAll: (filters?: any) => Promise<{ success: boolean; data: any }>
	getOne: (uuId: string) => Promise<{ success: boolean; data: any }>
	create: (data: any) => Promise<{ success: boolean; data: any }>
	update: (uuId: string, data: any) => Promise<{ success: boolean; data: any }>
	updateSupplierCreated: (uuId: string, data: any) => Promise<{ success: boolean; data: any }>
	send: (uuId: string) => Promise<{ success: boolean; data: any }>
	publish: (uuId: string) => Promise<{ success: boolean; data: any }>
	remove: (uuId: string) => Promise<{ success: boolean; data: any }>
	clearState: () => void
}

export const API_SLUG = '/supplier-quotations'

export const useQuotationStore = createWithEqualityFn<QuotationStore>(
	set => ({
		data: [],
		selected: {},
		setData: (data: any[]) => set({ data }),
		setSelected: (selected: any) => set({ selected }),
		getAll: async filters => {
			return axios
				.get(`${API_SLUG}`, {
					params: filters,
				})
				.then(res => {
					set({ data: res.data })
					return { success: true, data: res.data }
				})
				.catch(err => {
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		getOne: async (uuId: string) => {
			return axios
				.get(`${API_SLUG}/${uuId}`)
				.then(res => {
					set({ selected: res.data })
					return { success: true, data: res.data }
				})
				.catch(err => {
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		create: async data => {
			return axios
				.post(`${API_SLUG}`, data)
				.then(res => {
					return { success: true, data: res.data }
				})
				.catch(err => {
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		update: async (uuId: string, data: any) => {
			return axios
				.put(`${API_SLUG}/${uuId}`, data)
				.then(res => {
					return { success: true, data: res.data }
				})
				.catch(err => {
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		updateSupplierCreated: async (uuId: string, data: any) => {
			return axios
				.put(`${API_SLUG}/${uuId}/supplier-created`, data)
				.then(res => {
					return { success: true, data: res.data }
				})
				.catch(err => {
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		send: async (uuId: string) => {
			return axios
				.put(`${API_SLUG}/${uuId}/send`)
				.then(res => {
					return { success: true, data: res.data }
				})
				.catch(err => {
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		publish: async (uuId: string) => {
			return axios
				.put(`${API_SLUG}/${uuId}/publish`)
				.then(res => {
					return { success: true, data: res.data }
				})
				.catch(err => {
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		remove: async (uuId: string) => {
			return axios
				.delete(`${API_SLUG}/${uuId}`)
				.then(res => {
					return { success: true, data: res.data }
				})
				.catch(err => {
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		clearState: () => set({ data: [], selected: {} }),
	}),
	Object.is
)
